import { useEffect, useState } from "react";
import { katman, TELEFON_SORGU, TABLET_SORGU } from "../olcu";

/**
 * Ekran katmanını canlı izler: "telefon" | "tablet" | "masaustu".
 *
 * Yalnız katman DEĞİŞTİĞİNDE yeniden çizer — her resize olayında değil.
 * (Eski BelediyeSidebar.js:139-153 `resize` dinleyip her piksel için
 *  setState çağırıyordu; sürükleme sırasında yüzlerce render oluyordu.)
 *
 * FAZ-86 — tek eşik kaynağı: ../olcu.js
 */
export default function useKatman() {
  const [k, setK] = useState(() => katman());

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const mqTel = window.matchMedia(TELEFON_SORGU);
    const mqTab = window.matchMedia(TABLET_SORGU);
    const guncelle = () => setK(katman());

    // Safari 13 uyumu: addEventListener yoksa addListener
    const ekle = (mq) =>
      mq.addEventListener
        ? mq.addEventListener("change", guncelle)
        : mq.addListener(guncelle);
    const sil = (mq) =>
      mq.removeEventListener
        ? mq.removeEventListener("change", guncelle)
        : mq.removeListener(guncelle);

    ekle(mqTel);
    ekle(mqTab);
    return () => {
      sil(mqTel);
      sil(mqTab);
    };
  }, []);

  return k;
}
